import React from 'react';
import styles from './AddCompositionView.module.css';
import AddCompositionPanel from '../components/add-composition/AddCompositionPanel';
import useTheme from 'config/useTheme';

const AddCompositionView = () => {
    const { dark } = useTheme();
    return (
        <div className={`${styles.add_composition_view} ${dark ? styles.dark : ''}`}>
            <AddCompositionPanel />
        </div>
    )
}

export default AddCompositionView;